module.exports = __webpack_public_path__ + "static/company_sp-1d40c77a758074cda9474bee9f6d666b.svg";